import { Popup } from "components/common/Popup/Popup";
import { Content } from "./Content/Content";
import { TextBoxSettings } from "./Content/TextBoxSettings/TextBoxSettings";
import { IconSettingsMobile } from "./IconSettingsMobile/IconSettingsMobile";
import { Options } from "./Options/Options";
import { useBottomMenu } from "./useBottomMenu";

export const BottomMenu = () => {
    const { isPopupOpen, openPopup, closePopup, activeType } = useBottomMenu();

    return (
        <>
            <Popup
                isOpen={isPopupOpen}
                close={closePopup}
                content={<Content activeType={activeType} closePopup={closePopup} />}
            >
                <Options openPopup={openPopup} />
            </Popup>
            <TextBoxSettings />
            <IconSettingsMobile />
        </>
    );
};
